import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, getDoc } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseNotificationService {
  async getAllNotifications() {
    const notifRef = collection(db, 'notifications')
    const q = query(notifRef, orderBy('createdAt', 'desc'))
    const snapshot = await getDocs(q)
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getNotificationById(id) {
    const ref = doc(db, 'notifications', id)
    const snap = await getDoc(ref)
    if (snap.exists()) return { id: snap.id, ...snap.data() }
    return null
  }
}
